// extracted by mini-css-extract-plugin
module.exports = {"blockContentWrapper":"lift-tickets_blockContentWrapper__88PKt","currencyNotice":"lift-tickets_currencyNotice__jnKl2"};